function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgFactChecked = function SvgFactChecked(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 514.29 514.29"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M486.15 219.81a12.54 12.54 0 0 1 24.78-3.93q1.69 10.51 2.52 20.59c.56 6.9.84 13.81.84 20.68A257.36 257.36 0 1 1 407.66 48.69a12.57 12.57 0 0 1-14.75 20.36 232 232 0 1 0 96.2 188.09c0-6.38-.26-12.63-.74-18.73-.52-6.51-1.28-12.71-2.22-18.61Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M128.37 233.34a12.54 12.54 0 1 1 19.77-15.44l97.24 124.64L465.43 80.73a12.53 12.53 0 1 1 19.17 16.13L255 370.05a12.54 12.54 0 0 1-19.87.13L128.37 233.36Z"
  }));
};
export default SvgFactChecked;